import styled from "styled-components";
import { SolutionColorVariables } from "@smartsuite/types";

export const DropdownHelpWrapper = styled.div`
  padding: 2px 2px 0;
`;

export const DropdownHelpInner = styled.div`
  padding: 12px 7px 12px 16px;
  border-radius: 4px;
  background: ${(props) => props.theme.secondaryColor};
  display: flex;
  align-items: center;
`;

export const HelpText = styled.div`
  font-size: 12px;
  line-height: 18px;
`;

export const HideButton = styled.div`
  display: inline-flex;
  margin-top: 10px;
  font-size: 12px;
  line-height: 18px;
  color: ${SolutionColorVariables.sc1};
  cursor: pointer;
  transition: color 200ms ease;

  &:hover {
    color: ${SolutionColorVariables.sc3};
  }
`;

export const HelpLogoWrapper = styled.div`
  margin-right: 15px;
  width: 20px;
  height: 20px;
  min-width: 20px;
  border-radius: 50%;
  justify-content: center;
  align-items: center;
`;
